var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("transition", { attrs: { name: "slide-fade" } }, [
    _vm.showMsg
      ? _c("div", { attrs: { id: "cookies-warning" } }, [
          _c(
            "div",
            {
              staticClass:
                "d-flex justify-content-center flex-sm-row flex-column",
            },
            [
              _c("div", [
                _c("p", { staticClass: "font-weight-thin" }, [
                  _vm._v("OUR SITE USES COOKIES"),
                ]),
                _vm._v(" "),
                _c("p", { staticClass: "xxxsmall ls-07 font-weight-thin" }, [
                  _vm._v(
                    "If you continue to use our website you consent to the\n                    use of cookies as stated in our\n                    Cookie Policy."
                  ),
                ]),
              ]),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "mt-sm-0 mt-3",
                  on: {
                    click: function ($event) {
                      return _vm.setMsgCookie(false)
                    },
                  },
                },
                [
                  _c("i", { staticClass: "icon-check" }),
                  _vm._v("OK, I UNDERSTAND"),
                ]
              ),
            ]
          ),
        ])
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }


// WEBPACK FOOTER //
// ./src/js/components/cookies-msg/cookies-msg.vue